import { useEffect, useState } from "react";
import { useSubjectContext } from "../subjects-context";

export function useCadRotation() {
    const { cadRotation$ } = useSubjectContext();
    const [rotation, setRotation] = useState(0);

    useEffect(() => {
        const sub = cadRotation$.subscribe((updatedRotation) => {
            setRotation(updatedRotation);
        });

        return () => {
            sub.unsubscribe();
        };
    }, [cadRotation$]);

    return {
        rotation,
        setRotation: (value: number) => {
            cadRotation$.next(value);
        },
    };
}
